const contentTypes = {
  ARTICLE: "ARTICLE",
  GENERATION_GENIUS_VIDEO: "GENERATION_GENIUS_VIDEO",
  INTERACTIVE_VIDEO: "INTERACTIVE_VIDEO",
} as const;

export type ContentType = (typeof contentTypes)[keyof typeof contentTypes];

export const UNLEVELLED_CONTENT_TYPES: ContentType[] = [
  contentTypes.GENERATION_GENIUS_VIDEO,
];

export default contentTypes;
